type ParamsLink = {
    NFENumber: string;
    InscMunicipalNumber: string;
    NFEVerificationNumber: string;
}

export const HandleParseLinkNf = ({ NFENumber, InscMunicipalNumber, NFEVerificationNumber }: ParamsLink) => {
    return `https://nfe.prefeitura.sp.gov.br/contribuinte/notaprint.aspx?nf=${NFENumber}&inscricao=${InscMunicipalNumber}&verificacao=${NFEVerificationNumber}`;
}